const longHours = [
    {
        timestamp: 1638182445,
        value: 1.8,
        baseline: 1,
    },
    {
        timestamp: 1638286011,
        value: 0.5,
        baseline: 1,
    },
    {
        timestamp: 1638372411,
        value: 0.5,
        baseline: 0,
    },
    {
        timestamp: 1638458811,
        value: 1.5,
        baseline: 1,
    },
    {
        timestamp: 1638545211,
        value: 1,
        baseline: 2,
    },
    {
        timestamp: 1638631611,
        value: 1.9,
        baseline: 1,
    },
    {
        timestamp: 1638718011,
        value: 0.5,
        baseline: 0.5,
    },
];

const outOfHours = [
    {
        timestamp: 1638182445,
        value: 23,
        baseline: 20,
    },
    {
        timestamp: 1638286011,
        value: 13,
        baseline: 21,
    },
    {
        timestamp: 1638372411,
        value: 25,
        baseline: 17,
    },
    {
        timestamp: 1638458811,
        value: 20,
        baseline: 18,
    },
    {
        timestamp: 1638545211,
        value: 23,
        baseline: 9,
    },
    {
        timestamp: 1638631611,
        value: 17,
        baseline: 20,
    },
    {
        timestamp: 1638718011,
        value: 2,
        baseline: 15,
    },
];

const focusTime = [
    {
        timestamp: "1655424000",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655424000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655427600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655431200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655434800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655438400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655442000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655445600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655449200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655452800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655456400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655460000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655463600,
            },
            {
                messages: 240,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655467200,
            },
            {
                messages: 180,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655470800,
            },
            {
                messages: 120,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655474400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655478000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655481600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655485200,
            },
            {
                messages: 1020,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655488800,
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655492400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655496000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655499600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655503200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655506800,
            },
        ],
    },
    {
        timestamp: "1655510400",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655510400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655514000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655517600,
            },
            {
                messages: 0,
                focus: 0,
                huddles: 0,
                meetings: 0,
                timestamp: 1655521200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655524800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655528400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655532000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655535600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655539200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 400,
                focus: 0,
                timestamp: 1655542800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655546400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655550000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655553600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655557200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655560800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655564400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655568000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655571600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655575200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655578800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655582400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655586000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655589600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655593200,
            },
        ],
    },
    {
        timestamp: "1655596800",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655596800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655600400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655604000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655607600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655611200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655614800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655618400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655622000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655625600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655629200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655632800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655636400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655640000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655643600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655647200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655650800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655654400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655658000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655661600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655665200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655668800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655672400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655676000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655679600,
            },
        ],
    },
    {
        timestamp: "1655683200",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655683200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655686800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655690400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655694000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655697600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655701200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655704800,
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655708400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655712000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655715600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655719200,
            },
            {
                messages: 180,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655722800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655726400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655730000,
            },
            {
                messages: 300,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655733600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655737200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655740800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655744400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655748000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655751600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655755200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655758800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655762400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655766000,
            },
        ],
    },
    {
        timestamp: "1655769600",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655769600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655773200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655776800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655780400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655784000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655787600,
            },
            {
                messages: 300,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655791200,
            },
            {
                messages: 900,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655794800,
            },
            {
                messages: 120,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655798400,
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655802000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655805600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655809200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655812800,
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655816400,
            },
            {
                messages: 840,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655820000,
            },
            {
                messages: 420,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655823600,
            },
            {
                messages: 300,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655827200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655830800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655834400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655838000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655841600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655845200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655848800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655852400,
            },
        ],
    },
    {
        timestamp: "1655856000",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655856000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655859600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655863200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655866800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655870400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655874000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655877600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655881200,
            },
            {
                messages: 420,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655884800,
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655888400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                timestamp: 1655892000,
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655895600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655899200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655902800,
            },
            {
                messages: 540,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655906400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655910000,
            },
            {
                messages: 360,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655913600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655917200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655920800,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655924400,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655928000,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655931600,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655935200,
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                timestamp: 1655938800,
            },
        ],
    },
];

const fragmentation = [
    {
        subject: "repos",
        value: 3,
        items: ["Static", "FE Main", "BE Testing"],
        baseline: 1.42,
    },
    {
        subject: "languages",
        value: 2,
        items: ["JavaScript", "HTML"],
        baseline: 1.39,
    },
    {
        subject: "channels",
        value: 4,
        items: ["Tech", "FE Team", "BE Team"],
        baseline: 1.74,
    },
    {
        subject: "meetings",
        value: 3,
        items: [
            "Prepare architecture for AWS",
            "Daily Standup",
            "Next Sprint/Release technical planning",
        ],
    },
    {
        subject: "peopleMeet",
        value: 3,
        items: ["e.anderson@adadot.com", "j.hughes@adadot.com", "o.parker@adadot.com"],
    },
    {
        subject: "peopleChat",
        value: 9,
        items: [
            "Emily Anderson",
            "Jacob Hughes",
            "Olivia Parker",
            "Ethan Collins",
            "Ava Peterson",
            "Isabella Hayes",
            "Mason Brooks",
        ],
    },
    {
        subject: "peopleGit",
        value: 1,
        items: ["e.anderson@adadot.com"],
    },
];

const support = [
    { name: "Jello Biafra", value: 3402 },
    { name: "Henry Rollins", value: 26203 },
    { name: "Glen Danzig", value: 176203 },
];

const upskilling = {
    expectedTotal: 378,
    newTotal: 122,
    usage: {
        expected: [
            {
                language: "TypeScript",
                lines: 297,
                files: 15,
                users: 2,
            },
            {
                language: "JavaScript",
                lines: 181,
                files: 20,
                users: 2,
            },
        ],
        new: [
            {
                language: "Markdown",
                lines: 92,
                files: 1,
                users: 1,
            },
            {
                language: "YAML",
                lines: 130,
                files: 3,
                users: 1,
            },
        ],
    },
};

const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const getWellbeing = () => {
    return {
        longHours,
        fragmentation,
        outOfHours,
        focusTime,
        support,
        upskilling,
        meta,
    };
};

export default getWellbeing;
